import { useStore } from '@store/index';

export const useWorkflowSwitcher = () => {
  const { workflows, setSelectedWorkflowId } = useStore();

  const switchToWorkflow = (workflowId: string) => {
    if (!workflows[workflowId]) {
      return;
    }

    // Update the store — list pages (cases, campaigns) react to this
    // change and sync workflow_id to the URL search param via their own useEffect.
    setSelectedWorkflowId(workflowId);
  };

  return { switchToWorkflow };
};
